interface FooterLink {
  label: string;
  href: string;
  ext?: boolean;
}
interface FooterCol {
  title: string;
  links: FooterLink[];
}

const COLUMNS: FooterCol[] = [
  {
    title: "Product",
    links: [
      { label: "Marketplace", href: "#" },
      { label: "Studio", href: "#" },
      { label: "Pricing", href: "#" },
      { label: "Changelog", href: "#" },
      { label: "Roadmap", href: "#" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Docs", href: "#" },
      { label: "Help center", href: "#" },
      { label: "Status", href: "#", ext: true },
      { label: "Contact", href: "mailto:hello@automaton.gg" },
      { label: "Bug reports", href: "#" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "#" },
      { label: "Manifesto", href: "#" },
      { label: "Press", href: "#" },
      { label: "Careers", href: "#" },
      { label: "Privacy", href: "#" },
    ],
  },
  {
    title: "Social",
    links: [
      { label: "Discord", href: "#", ext: true },
      { label: "Mastodon", href: "#", ext: true },
      { label: "Bluesky", href: "#", ext: true },
      { label: "GitHub", href: "#", ext: true },
      { label: "RSS", href: "#" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand-block">
          <div className="footer__brand">
            <img className="mark" src="/logo-mark.svg" alt="" />
            <img className="wordmark" src="/logo-wordmark.svg" alt="AUTOMATONS.APP" />
          </div>
          <div className="footer__tag">
            I&rsquo;m a small machine. I&rsquo;d like to keep working.
          </div>
          <div className="footer__voice">hello@automatons.app · +1 (415) 555-0142</div>
        </div>

        {COLUMNS.map((c) => (
          <div className="footer__col" key={c.title}>
            <div className="footer__col-title">{c.title}</div>
            <ul>
              {c.links.map((lk) => (
                <li key={lk.label}>
                  <a href={lk.href}>
                    {lk.label}
                    {lk.ext && <img className="ext" src="/icons/external-link.svg" alt="" />}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="footer__bottom">
        <div className="footer__bottom-left">
          <span>© 2026 Terra2</span>
          <span className="sep">/</span>
          <span>Made in LA · SF · LV</span>
          <span className="sep">/</span>
          <span>Build 2026.05.04-r3</span>
        </div>
        <div className="footer__bottom-right">
          <span>
            <span className="heart" />
            1,247 automatons alive
          </span>
          <span>
            uptime <b>99.94%</b>
          </span>
          <span>
            core <b style={{ color: "var(--color-energy)" }}>stable</b>
          </span>
        </div>
      </div>
    </footer>
  );
}
